import { PageLoading } from "@ant-design/pro-layout";
import NoResults from "./NoResults/NoResults";
import TopBar from "./TopBar/TopBar";
import "./style.less";
import { IFile } from "../../../services/File";
import ImagenItem from "./ImagenItem/ImagenItem";

interface ResultsScreenProps {
  imagenes: IFile[];
  loading: boolean;
  cleanSearch: () => void;
  termSearched: string;
}

const ResultsScreen: React.FC<ResultsScreenProps> = (props) => {
  const {
    imagenes,
    loading,
    cleanSearch,
    termSearched,
  } = props;

  if (loading) {
    return <PageLoading />;
  }

  if (imagenes.length) {
    return (
      <div className="ResultsScreen">
        <TopBar
          description={"Imágenes encontradas"}
          results={imagenes.length}
          title={termSearched.toUpperCase()}
          handleClose={cleanSearch}
          filterFeature={false}
        />
        {imagenes.map((imagen: IFile, index: number) => (
          <ImagenItem key={index} imagen={imagen} />
        ))}
      </div>
    );
  }

  return (
    <div className="ResultsScreen">
      <NoResults />
    </div>
  );
};

export default ResultsScreen;
